module.exports = __webpack_public_path__ + "static/img/q0010_s.5da8226.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ribenurl/q0010_s.jpg
// module id = aofM
// module chunks = 23